import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 从 localStorage 获取用户信息
const savedUserInfo = localStorage.getItem('userInfo')
const initialUserInfo = savedUserInfo ? JSON.parse(savedUserInfo) : null

export default new Vuex.Store({
  state: {
    userInfo: initialUserInfo  // 初始化时从 localStorage 获取
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
      // 将用户信息保存到 localStorage
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    clearUserInfo(state) {
      state.userInfo = null
      localStorage.removeItem('userInfo')
    }
  }
})
